export default __webpack_public_path__ + "static/media/more_revenue.59fea81d.png";